<template>
  <div class="result">
    <div class="icon"></div>
    <ResultCommon v-if="resultState.showType === 'common'"></ResultCommon>
    <ResultCollect
      v-if="resultState.showType === 'collectInfo'"
    ></ResultCollect>
    <ResultCode v-if="resultState.showType === 'series'"></ResultCode>
    <ResultAward v-if="resultState.showType === 'award'"></ResultAward>
  </div>
</template>
<script setup>
import ResultCommon from "@/components/result/ResultCommon.vue";
import ResultCollect from "@/components/result/ResultCollect.vue";
import ResultAward from "@/components/result/ResultAward.vue";
import ResultCode from "@/components/result/ResultCode.vue";
import resultHook from "@/hooks/resultHook";
const { resultState } = resultHook();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";
.result {
  @include setBackground(100%, auto, "default_bg.jpg");
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: auto;
  @media (orientation: landscape) {
    padding-top: 140px;
  }
  @media (orientation: portrait) {
    padding-top: 140px;
  }
  .icon {
    @include setBackground(207px, 222px, "result_icon.png");
    background-size: contain;
    margin-bottom: 20px;
    @media (orientation: landscape) {
      width: 207px;
      height: 222px;
      margin-bottom: 20px;
    }
  }
}
</style>
